import React, { useEffect, useState } from 'react';

import PageLayout from 'components/layouts/PageLayout';
import { AdminPromotionDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import NewButton from 'components/input/NewButton';

import PromotionsCard from 'components/pages/promotion/PromotionsCard';

import PromotionForm from 'components/pages/promotion/PromotionForm';
import PromotionView from 'components/pages/promotion/PromotionView';
import { toast } from 'react-toastify';

const PromotionsPage = () => {
  const { uiStore } = useStoreWrapper();

  const [promotions, setPromotions] = useState<AdminPromotionDto[]>([]);

  const handleClickPromotion = (promotion: AdminPromotionDto) => {
    uiStore?.modal.show({
      title: '프로모션 상세',
      style: { width: '800px', maxHeight: '80vh', height: '100%' },
      children: (
        <PromotionView
          promotion={promotion}
          onSave={fetchPromotions}
          onChange={() => {
            uiStore?.modal.close();
            setTimeout(() => {
              handleAddPromotion(promotion);
            }, 100);
          }}
        />
      ),
    });
  };

  const handleAddPromotion = (promotion?: AdminPromotionDto) => {
    uiStore?.modal.show({
      title: promotion?.id ? '프로모션 수정' : '프로모션 추가',
      style: { width: '1200px', maxHeight: '80vh', height: '100%' },
      children: (
        <PromotionForm
          onSave={() => {
            fetchPromotions();
          }}
          promotion={promotion}
        />
      ),
      onConfirmed: () => {
        fetchPromotions();
      },
    });
  };

  const handleChangeIsActive = (isActive: boolean, promotion: AdminPromotionDto) => {
    ServiceHelper.adminPromotionService
      ?.updatePromotion(promotion.id as number, {
        ...promotion,
        isActive: isActive,
      })
      .then((res) => {
        if (res.status === 200) {
          toast.success('프로모션 상태가 변경되었습니다.');
          fetchPromotions();
        }
      });
  };

  const fetchPromotions = () => {
    ServiceHelper.adminPromotionService?.getPromotions1().then((res) => {
      setPromotions(res.data);
    });
  };

  useEffect(() => {
    fetchPromotions();
  }, []);

  return (
    <PageLayout
      title="프로모션관리"
      actionButton={<NewButton onClick={handleAddPromotion}>프로모션추가</NewButton>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 30 }}>
        {promotions.map((promotion) => (
          <PromotionsCard
            onChangeIsActive={(isActive) => {
              handleChangeIsActive(isActive, promotion);
            }}
            key={promotion.id}
            promotion={promotion}
            onClick={() => {
              handleClickPromotion(promotion);
            }}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default PromotionsPage;
